import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { getDiscountValue, NumberFormat, NumberFormatFloat } from "utils/HelperFunction";
var DiscountInput = function(param) {
    var sumproductPrice = param.sumproductPrice, _param_fieldName = param.fieldName, fieldName = _param_fieldName === void 0 ? "discount_price" : _param_fieldName;
    var _useFormikContext = useFormikContext(), values = _useFormikContext.values, setFieldValue = _useFormikContext.setFieldValue;
    useEffect(function() {
        var updatedDiscountPrice = NumberFormatFloat(getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), 4);
        setFieldValue(fieldName, updatedDiscountPrice);
    }, [
        values.dim_mst_discount_type_id,
        sumproductPrice,
        values.discount_value
    ]);
    return /*#__PURE__*/ _jsx("input", {
        className: "form-control text-end",
        style: {
            width: "120px",
            borderBottomWidth: "1px"
        },
        readOnly: true,
        value: NumberFormat(getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), 2)
    });
};
export default DiscountInput;
